var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 110,
    viewBox: "0 0 119 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.112 49.9761L93.4544 36.6937L95.0788 19.1113L77.8309 15.1935L68.8008 0L52.5561 6.97563L36.3115 0L27.2814 15.1935L10.0334 19.0635L11.6579 36.646L0 49.9761L11.6579 63.2585L10.0334 80.8887L27.2814 84.8065L36.3115 100L52.5561 92.9766L68.8008 99.9522L77.8309 84.7587L95.0788 80.8409L93.4544 63.2585L105.112 49.9761ZM43.0005 73.8653L23.8892 54.7539L30.6259 48.0172L43.0005 60.344L74.4864 28.8581L81.2231 35.6426L43.0005 73.8653Z",
    fill: "#00C24E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 72,
    r: 7,
    fill: "#003A50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27,
    r: 9,
    fill: "#FFF16F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 100,
    r: 10,
    fill: "#FFA463"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.8574d6b3888e0bbdc9215d5396635255.svg";
export { ForwardRef as ReactComponent };